'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'sailboat';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M47.3 311.5c-6.7 10.7 1 24.5 13.6 24.5L176 336c8.8 0 16-7.2 16-16l0-184.2c0-16.1-21-22.1-29.6-8.5L47.3 311.5zM240 35.9c0 226 0 342.3 0 348.1l48 0 0-48 161.7 0c12.9 0 20.5-14.4 13.2-25L269.2 26.9c-8.9-13-29.2-6.7-29.2 9z', 'M0 400c0-8.8 7.2-16 16-16l480 0c8.8 0 16 7.2 16 16 0 61.9-50.1 112-112 112l-288 0C50.1 512 0 461.9 0 400z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;